<template>
  <div>
    <Mainl :activeName="activeTab"></Mainl>
    <div class="page_content">
      <div class="change_password_content">
        <div class="change_password_content_title">修改密码</div>
        <div class="change_password_content_form_wrap">
          <el-form ref="ruleForm" :model="ruleForm" status-icon label-width="100px" class="demo-ruleForm">
            <el-form-item label="旧密码" prop="pass" :rules="[
      { validator: checkPwd, trigger: 'blur'},
    ]">
              <el-input placeholder="请输入账号当前密码" style="width: 336px;" type="password" v-model="ruleForm.pass"
                autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item :rules="[
            { required: true, message: '请输入新密码'},
          ]" label="新密码" prop="newPass">
              <el-input placeholder="请输入6-16位密码，区分大小写" style="width: 336px;" type="password" v-model="ruleForm.newPass"
                autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item :rules="[
            { validator: checkPass, trigger: 'blur'},
          ]" label="确认密码" prop="checkPass">
              <el-input placeholder="请再次输入密码" style="width: 336px;" type="password" v-model="ruleForm.checkPass"
                autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button style="height: 40px;padding: 9px 98px;" type="primary" :disabled="form_disabled"
                @click="submitForm('ruleForm')">提交</el-button>
              <!-- <el-button style="height: 40px;padding: 9px 34px;">取消</el-button> -->
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
  import Mainl from '@/components/Mainl.vue'
  import Cookies from "js-cookie";
  import * as commfun from "@/common/common.js"

  // import index_mixins_page from "@/common/index_mixins_page.js"
  export default {
    name: 'Index',
    components: {
      Mainl,
    },
    data: function () {
      return {
        activeTab: "",
        form_disabled: false,
        ruleForm: {
          pass: '',
          checkPass: '',
          newPass: ''
        }
      };
    },
    mounted() {
      //this.initdict()
      commfun.ajaxOnline(this)
    },

    computed: {

    },
    methods: {
      checkPwd(rule, value, callback) {
        if (value === '') {
          callback(new Error('请输入旧密码'));
        } else if (!this.alidateInput(value)) {
          callback(new Error('密码仅支持输入英文字母和数字，限制输入6-16字符'));
        } else {
          callback();
        }
      },
      checkPass(rule, value, callback) {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.newPass) {
          callback(new Error('两次输入密码不一致!'));
        } else if (!this.alidateInput(value)) {
          callback(new Error('密码仅支持输入英文字母和数字，限制输入6-16字符'));
        } else {
          callback();
        }
      },
      //判断新密码仅支持输入英文字母和数字，限制输入6-16字符
      alidateInput(textInput) {
        let regex = /^[a-zA-Z0-9]{6,16}$/;
        if (!regex.test(textInput)) {
          return false;
        }
        return true;
      },
      submitForm(formName) {
        var selfthis = this
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var url = '/api/api/user/pwdreset'
            selfthis.form_disabled = true
            var postdata = {
              pass: selfthis.ruleForm.pass,
              newPass: selfthis.ruleForm.newPass,
              checkPass: selfthis.ruleForm.checkPass,
            }
            commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
              console.log(data)
              commfun.showMessage(selfthis, 'success', "密码修改成功，请重新登录")
              setTimeout(function () {
                window.location.href = "/"
              }, 500)
              return true
            }, function (selfthis, dataError) {
              selfthis.form_disabled = false
              commfun.showMessage(selfthis, 'warning', "错误：" + dataError.msg)
            })


          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Pwdreset.vue